import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from '../css/UpcomingService.module.css';
import axios from 'axios';
import { FaCircleCheck } from 'react-icons/fa6';
import OfferImage from '../components/OfferImage';
import { FaHome, FaUser } from 'react-icons/fa';
import HeaderBar from '../components/HeaderBar';

function UpcomingService() {
	const [services, setServices] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [agents, setAgents] = useState({}); // State to store agents' details by service
	const navigate = useNavigate();

	// Fetch user email from localStorage
	const userEmail = JSON.parse(localStorage.getItem('user'))?.email;

	// Fetch services based on the user's email
	useEffect(() => {
		if (!userEmail) {
			navigate('/');
			return;
		}

		const fetchServices = async () => {
			try {
				const response = await axios.get(
					'https://hometech-repairs.in/customerDB/FetchBooking.php',
					{
						params: { email: userEmail },
					}
				);
				if (response.data.status) {
					setServices(response.data.data);
				} else {
					setError('No upcoming services found');
				}
			} catch (err) {
				setError('Failed to fetch services. Please try again later.');
			} finally {
				setLoading(false);
			}
		};

		fetchServices();
	}, [userEmail, navigate]);

	useEffect(() => {
		const fetchAgentDetails = async (agentId) => {
			try {
				const response = await fetch(
					`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${agentId}`
				);
				const result = await response.json();
				if (result.status) {
					setAgents((prevAgents) => ({
						...prevAgents,
						[agentId]: result.data, // Store agent details by agentId
					}));
				}
			} catch (err) {
				console.error('Error fetching agent details:', err);
			}
		};

		// Call the fetchAgentDetails function for each unique agent_id
		services.forEach((service) => {
			if (service.agent_id && !agents[service.agent_id]) {
				fetchAgentDetails(service.agent_id);
			}
		});
	}, [services, agents]);

	return (
		<div>
			{/* <Navbar /> */}
			<HeaderBar
				text={'Upcoming Services'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.main}>
				{loading ? (
					<p>Loading...</p>
				) : error ? (
					<p>{error}</p>
				) : (
					<div>
						{services.length > 0 ? (
							<div className={style.services}>
								{services.map((service, index) => {
									const agent = agents[service.agent_id];
									return (
										<div key={index} className={style.serviceCard}>
											<p className={style.date}>
												{new Date(service.date).toLocaleDateString('en-GB')}
											</p>

											<p className={style.orNbr}>{service.order_number}</p>
											<div className={style.rows}>
												<FaCircleCheck color="green" />
												<p>Booking Created</p>
											</div>
											{/* <div className={style.side}>
												<p>Name: {service.name}</p>
												<p>
													Phone:
													{service.phone}
												</p>
											</div> */}

											<div className={style.side}>
												<div className={style.agentDetails}>
													<p>Name: {agent.name}</p>
													<p>Phone: {agent.phone}</p>
												</div>
											</div>

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'orange'
															: service.status === 'Accepted'
															? 'green'
															: service.status === 'Work in progress'
															? 'green'
															: service.status === 'Completed'
															? 'green'
															: 'orange'
													}
												/>
												<p>
													{service.status === 'Created'
														? 'Waiting to accept'
														: 'Accepted'}
												</p>
											</div>

											<div className={style.side}>
												{agent && (
													<div className={style.agentDetails}>
														<p>Name: {agent.name}</p>
														<p>Phone: {agent.phone}</p>
														{/* <p>ID: {agent.agent_id}</p> */}
													</div>
												)}
											</div>

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Created'
															? 'orange'
															: service.status === 'Accepted'
															? 'orange'
															: service.status === 'Work in progress'
															? 'green'
															: service.status === 'Completed'
															? 'green'
															: 'orange'
													}
												/>
												<p>Work in progress</p>
											</div>

											<div className={style.rows}>
												<FaCircleCheck
													color={
														service.status === 'Completed' ? 'green' : 'orange'
													}
												/>
												<p>Completed</p>
											</div>

											{service.status === 'Completed' && (
												<Link
													className={style.invoice}
													to={`/invoice/${service.order_number}`}
												>
													View Invoice
												</Link>
											)}
										</div>
									);
								})}
							</div>
						) : null}
					</div>
				)}
			</div>
		</div>
	);
}

export default UpcomingService;
